export enum PriceDisplayType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  PRIMARY_OPTIONS = 'primaryOptions',
  SECONDARY_OPTIONS = 'secondaryOptions',
  FINANCE = 'finance',
  CASH = 'cash',
}
